<template>
  <div class="form-group">
    <label class="form-label">{{ label }}</label>
    <input
        type="file"
        class="dropify"
        ref="dropifyInput"
        :data-height="height"
        :data-max-file-size="maxSize"
        :data-allowed-file-extensions="allowedExtensions.join(' ')"
        :data-default-file="defaultFile"
        :data-show-remove="showRemove"
        :data-show-loader="showLoader"
        :data-show-errors="showErrors"
        :multiple="multiple"
        @change="onFileChange"
    />
  </div>
</template>

<script>
  import 'dropify/dist/css/dropify.min.css'
  import 'dropify/dist/js/dropify.min.js'
  import $ from 'jquery'

  export default {
    name: 'DropifyUploader',
    props: {
      label: {
        type: String,
        default: 'Téléverser une image'
      },
      height: {
        type: Number,
        default: 180
      },
      maxSize: {
        type: String,
        default: '3M'
      },
      allowedExtensions: {
        type: Array,
        default: () => ['jpg', 'png']
      },
      defaultFile: {
        type: String,
        default: ''
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRemove: {
        type: Boolean,
        default: true
      },
      showLoader: {
        type: Boolean,
        default: true
      },
      showErrors: {
        type: Boolean,
        default: true
      }
    },
    mounted() {
      const input = this.$refs.dropifyInput;

      // Initialisation Dropify avec messages en français
      $(input).dropify({
        messages: {
          default: 'Glissez-déposez un fichier ici ou cliquez',
          replace: 'Glissez-déposez un fichier ou cliquez pour remplacer',
          remove: 'Supprimer',
          error: 'Fichier invalide.'
        },
        error: {
          fileSize: 'Le fichier est trop volumineux (max: {{ value }}).',
          imageFormat: 'Format non autorisé ({{ value }} seulement).'
        }
      });
    },
    methods: {
      onFileChange(event) {
        const files = event.target.files;
        this.$emit('file-change', files);
      },
      reset() {
        const dropifyInstance = $(this.$refs.dropifyInput).data('dropify');
        if (dropifyInstance) {
          dropifyInstance.resetPreview();
          dropifyInstance.clearElement();
        }
      }
    }
  };
</script>
